module.exports = __webpack_public_path__ + "static/GoldminesPlay-55916f36f5c8c6edd4f988430cd42966.jpeg";